import React from 'react';
import {
  IconBriefcaseOff,
  IconCalendar,
  IconClockHour8,
  IconGiftCard,
  IconMap2,
  IconReportMoney,
  IconUmbrella,
} from '@tabler/icons-react';
import dayjs from 'dayjs';
import { Group, Text } from '@mantine/core';

import { capitalize } from '@/helpers';
import { MealFactor, PopupEventVendorDetailsUpcoming } from '../types';
import { FACTOR_TYPE } from './popup-upcoming.constants';

type MealPrepFactorProps = {
  factor: MealFactor;
  event: PopupEventVendorDetailsUpcoming;
};

const MealPrepFactor: React.FC<MealPrepFactorProps> = ({ factor, event }) => {
  if (!factor.value || !Object.values(FACTOR_TYPE).includes(factor.type as FACTOR_TYPE)) {
    return null;
  }

  const start = dayjs(event.popupEvent.startTime).format('dddd');
  const accountName = event.popupEvent.account.name;

  const Icon = {
    [FACTOR_TYPE.SUBSIDIZED]: IconGiftCard,
    [FACTOR_TYPE.LAST_VISIT]: IconClockHour8,
    [FACTOR_TYPE.IS_FIRST_VISIT]: IconClockHour8,
    [FACTOR_TYPE.HOLIDAY]: IconCalendar,
    [FACTOR_TYPE.SOLD_OUT]: IconBriefcaseOff,
    [FACTOR_TYPE.WEATHER]: IconUmbrella,
    [FACTOR_TYPE.IS_BETTER_SALES_DAY_OF_WEEK]: IconReportMoney,
    [FACTOR_TYPE.SAME_LOCATION_EVENTS]: IconMap2,
  }[factor.type as FACTOR_TYPE];

  const factorText = {
    [FACTOR_TYPE.SUBSIDIZED]: 'Customers use a company-paid subsidy at this location',
    [FACTOR_TYPE.LAST_VISIT]: `You last visited this location on ${dayjs(factor.value).format(
      'MM/DD/YYYY'
    )}`,
    [FACTOR_TYPE.IS_FIRST_VISIT]: 'This is your first visit to this location',
    [FACTOR_TYPE.HOLIDAY]: 'There is a holiday on the calendar for this week',
    [FACTOR_TYPE.SOLD_OUT]: 'You sold out of at least 1 item at this location on your last visit',
    [FACTOR_TYPE.WEATHER]: `${capitalize(factor.value)} is expected on ${start}`,
    [FACTOR_TYPE.IS_BETTER_SALES_DAY_OF_WEEK]: `Sales are typically stronger on ${start} at this location`,
    [FACTOR_TYPE.SAME_LOCATION_EVENTS]: `This prep number considers your sales history at ${accountName} over the last ${factor.value} events`,
  }[factor.type as FACTOR_TYPE];

  return (
    <Group gap="md">
      <Icon size="1.5rem" />
      <Text>{factorText}</Text>
    </Group>
  );
};

export default MealPrepFactor;
